import clsx from "clsx"
import React from "react"
import { Alert as ReactBootstrapAlert } from "react-bootstrap"
import "./alert.css"

export enum AlertVariant {
    PRIMARY = "primary",
    SECONDARY = "secondary",
    SUCCESS = "success",
    DANGER = "danger",
    WARNING = "warning",
    INFO = "info",
    LIGHT = "light",
    DARK = "dark",
}

interface Props {
    alertHeader?: string
    alertBody: string
    className?: string
    dismissible?: boolean
    onClose?: () => void
    variant: AlertVariant
}

export const Alert: React.FC<Props> = ({ alertHeader, alertBody, className, onClose, dismissible, variant }) => {
    return (
        <ReactBootstrapAlert
            variant={variant}
            onClose={onClose}
            dismissible={dismissible}
            className={clsx("common-alert", className)}
        >
            {alertHeader && (
                <ReactBootstrapAlert.Heading className={clsx("common-alert-heading", "h5")}>
                    {alertHeader}
                </ReactBootstrapAlert.Heading>
            )}
            <p>
                {alertBody}
            </p>
        </ReactBootstrapAlert>
    )
}


// WEBPACK FOOTER //
// ./src/common/alert/Alert.tsx